export function FirstCapital(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
